import type { ComponentType } from "react";
import { useParams } from "react-router-dom";
import { ADDED_TO_CART_DIALOG_SEGMENT } from "@features/ecommerce/constants/cartRouteSegments";

type QuotePageRouteProps = Readonly<{
  listPage: ComponentType;
  detailPage: ComponentType;
  forceList?: boolean;
}>;

export default function QuotePageRoute({
  listPage: ListPage,
  detailPage: DetailPage,
  forceList = false,
}: QuotePageRouteProps) {
  const { quoteId } = useParams();
  const Page =
    forceList ||
    quoteId === undefined ||
    quoteId === ADDED_TO_CART_DIALOG_SEGMENT
      ? ListPage
      : DetailPage;

  return <Page />;
}
